import { provideWidgetClass } from 'scrivito'

export const DXPSearchResultsWidget = provideWidgetClass(
  'DXPSearchResultsWidget',
  {
    attributes: {},
  },
)
